import React from 'react';

interface GradeSelectionProps {
  handleGradeSelect: (grade: number) => void;
  isZambianSecondary?: boolean;
}

export const GradeSelection: React.FC<GradeSelectionProps> = ({ handleGradeSelect, isZambianSecondary }) => {
  // Only keeping levels that have more topics explained (Forms 1, 3, 4)
  const levels = isZambianSecondary ? [1, 3, 4] : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const levelLabel = isZambianSecondary ? 'Form' : 'Grade';

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #15803d 0%, #166534 100%)',
      padding: '12px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '24px',
        maxWidth: '500px',
        width: '100%',
        overflow: 'hidden',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
      }}>
        <div style={{
          background: 'linear-gradient(135deg, #15803d, #16a34a)',
          padding: '32px',
          textAlign: 'center',
          color: 'white'
        }}>
          <h1 style={{ fontSize: '28px', marginBottom: '8px' }}>Zambia Smart Learning</h1>
          <p style={{ opacity: 0.9 }}>Competence-Based Learning Platform</p>
        </div>
        
        <div style={{ padding: '32px' }}>
          <h2 style={{ fontSize: '18px', marginBottom: '16px', textAlign: 'center' }}>
            Select Your {levelLabel} Level
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(80px, 1fr))',
            gap: '12px'
          }}>
            {levels.map(level => (
              <button
                key={level}
                onClick={() => handleGradeSelect(level)}
                style={{
                  padding: '16px',
                  border: '2px solid #e5e7eb',
                  background: 'white',
                  borderRadius: '12px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#15803d';
                  e.currentTarget.style.background = '#f0fdf4';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#e5e7eb';
                  e.currentTarget.style.background = 'white';
                }}
              >
                {levelLabel} {level}
              </button>
            ))}
          </div>
        </div>
        
        <div style={{
          padding: '20px 32px',
          background: '#f9fafb',
          textAlign: 'center',
          fontSize: '12px',
          color: '#6b7280',
          borderTop: '1px solid #e5e7eb'
        }}>
          <p>Aligned with Zambian Competence-Based Curriculum Framework</p>
        </div>
      </div>
    </div>
  );
};
